import { createContext } from 'react';
export const AuthContext = /*#__PURE__*/createContext(undefined);